import { AfterViewInit, Component, EventEmitter, OnInit } from '@angular/core';
import { MerchantService } from 'src/app/services/merchant/merchant.service';
import * as moment from 'moment';

@Component({
  selector: 'app-dashboard-v2',
  templateUrl: './dashboard-v2.component.html',
  styleUrls: ['./dashboard-v2.component.scss']
})
export class DashboardV2Component implements OnInit {

  genReportEvent: EventEmitter<string>;
  merchantGroups: [];

  query = {
    startDate: new Date(),
    endDate: new Date(),
    merchantGroupIds: '',
  };

  constructor(private merchantService: MerchantService) {
    this.genReportEvent = new EventEmitter<string>();
  }

  ngAfterViewInit() {
    setTimeout(_ => this.genReports(), 500);
  }

  ngOnInit(): void {
    this.getMerchantGroups();
    this.genReports();
  }

  getMerchantGroups() {
    this.merchantService.getGrantedMerchantGroups().subscribe(data => {
      this.merchantGroups = data;
    });
  }

  genReports() {
    this.genReportEvent.next();
  }
}
